import React from 'react';

import Lightbox from '../molecules/Lightbox';

import { useLightbox } from '../context/lightboxContext';

const Layout = ({ children }) => {
  const { activeLightbox } = useLightbox();

  return (
    <div>
      <Lightbox {...activeLightbox} />
      {children}
    </div>
  );
};

export default Layout;
